module.exports = __webpack_public_path__ + "img/20200406_152518.64fe549f.jpg";